// extracted by mini-css-extract-plugin
module.exports = {"dialogAlerrtSuccessAdd":"DialogLeaveWarning_dialogAlerrtSuccessAdd_dvxDQ"};